// src/features/dashboard/hooks/useKpi.ts

import {
  useEffect,
  useState,
} from 'react';

import {
  getKpiCardsApi,
} from '../services/kpiApi';

import {
  mapKpiCards,
  kpiMockData,
} from '../mocks/kpi.mock';

import {
  ENV,
} from '../../../config/env';

import type {
  KPIItem,
} from '../types/kpi.types';

import type {
  KpiTrendRequest,
} from '../types/kpiTrend.types';

import {
  useDashboardDate,
} from '../context/DashboardDateContext';

import {
  formatApiDate,
} from '../utils/date.utils';

export const useKpi = (
  ManagerEmployeeCode: string,
) => {

  const {
    fromDate,
    toDate,
  } = useDashboardDate();

  const [kpiCards, setKpiCards] =
    useState<KPIItem[]>([]);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState('');

  useEffect(() => {

    if (
      !ManagerEmployeeCode ||
      Number.isNaN(
        ManagerEmployeeCode,
      )
    ) {
      return;
    }

    const fetchKpiData =
      async () => {

        try {

          setLoading(true);
          setError('');

          /**
           * MOCK MODE
           */
          if (
            ENV.USE_MOCK
          ) {

            setKpiCards(
              mapKpiCards(
                kpiMockData,
              ),
            );

            return;
          }

          /**
           * API MODE
           */
          const payload: KpiTrendRequest = {
            ManagerEmployeeCode:
              String(
                ManagerEmployeeCode,
              ),

            fromDate:
              formatApiDate(
                fromDate,
              ),

            toDate:
              formatApiDate(
                toDate,
              ),

            productiveHoursThreshold:
              1,

            daysThreshold:
              1,

            workMode:
              null,
          };

          const response =
            await getKpiCardsApi(
              payload,
            );

          setKpiCards(
            mapKpiCards(
              response,
            ),
          );

        } catch (err) {

          console.error(
            'KPI Error:',
            err,
          );

          setError(
            'Failed to load KPI data',
          );

        } finally {

          setLoading(
            false,
          );
        }
      };

    fetchKpiData();

  }, [
    ManagerEmployeeCode,
    fromDate,
    toDate,
  ]);

  return {
    kpiCards,
    loading,
    error,
  };
};